import {
  Files,
  NoteBlank,
  PaperPlaneTilt,
  Star,
  Tag,
} from "@phosphor-icons/react";

import type { Lead } from "common/types";

export const MANAGE_LEADS_ACTIONS = {
  labels: {
    icon: Tag,
    getLabel: () => "Add labels",
    getEligibleItems: (selection: Lead[]) => selection,
    isPopup: true,
  },
  notes: {
    icon: NoteBlank,
    getLabel: () => "Add notes",
    getEligibleItems: (selection: Lead[]) => selection,
  },
  favorite: {
    icon: Star,
    getLabel: () => "Favorite leads",
    getEligibleItems: (selection: Lead[]) =>
      selection.filter((lead) => !lead.favorite),
  },
  unfavorite: {
    icon: Star,
    getLabel: () => "Unfavorite leads",
    getEligibleItems: (selection: Lead[]) =>
      selection.every((lead) => lead.favorite) ? selection : [],
  },
} as const;

export const OUTREACH_CRM_EXPORT_OPTIONS = {
  campaign: {
    icon: PaperPlaneTilt,
  },
  list: {
    icon: Files,
  },
};

export const LEADS_TAB_ITEMS = [
  { label: "Leads", path: "" },
  { label: "Labels", path: "labels" },
];
